// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"orderSearch_searchInput__1I-et","searchIcon":"orderSearch_searchIcon__83auu"};